(() => {
  'use strict';


  const dashboard =
    document.querySelector(
      '[data-pnadm-dashboard]'
    );


  const mentorView =
    dashboard?.querySelector(
      '[data-pnadm-view="mentors"]'
    );


  if (
    !dashboard ||
    !mentorView
  ) {
    return;
  }


  let mounted =
    false;

  let mentors =
    [];

  let search =
    '';

  let statusFilter =
    'all';

  let visibilityFilter =
    'all';


  function escapeHTML(value) {

    return String(
      value ?? ''
    )
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');

  }


  function pill(value) {

    const state =
      String(
        value ||
        'unknown'
      )
        .toLowerCase();


    return `
      <span
        class="pnops__pill"
        data-state="${escapeHTML(state)}"
      >
        ${escapeHTML(
          state.replaceAll(
            '_',
            ' '
          )
        )}
      </span>
    `;

  }


  /* PN_MENTOR_MANAGEMENT_PAYMENTS_DIRECT_V1 */

  function money(
    value,
    currency = 'INR'
  ) {

    return new Intl.NumberFormat(
      'en-IN',
      {
        style:'currency',
        currency:
          currency || 'INR',
        maximumFractionDigits:2
      }
    ).format(
      Number(
        value || 0
      )
    );

  }


  function applicationCards() {

    return [
      ...mentorView.children
    ]
      .filter(
        node =>
          node.matches?.(
            '.pnadm-card'
          ) &&
          !node.matches?.(
            '[data-pnadm-mentor-manager]'
          )
      );

  }


  function mount() {

    if (mounted) {
      return;
    }


    const heading =
      mentorView.querySelector(
        '.pndash-section-heading'
      );


    if (!heading) {
      return;
    }


    const tabs =
      document.createElement(
        'div'
      );


    tabs.className =
      'pnadm-mentor-tabs';


    tabs.innerHTML = `
      <button
        type="button"
        class="is-active"
        data-pnadm-mentor-tab="applications"
      >
        Applications
      </button>

      <button
        type="button"
        data-pnadm-mentor-tab="management"
      >
        Mentor Management
      </button>
    `;


    heading.after(
      tabs
    );


    const manager =
      document.createElement(
        'section'
      );


    manager.className =
      'pnadm-card';


    manager.setAttribute(
      'data-pnadm-mentor-manager',
      ''
    );


    manager.hidden =
      true;


    manager.innerHTML = `
      <div class="pnadm-card__head">

        <div>

          <span>
            MENTOR OPERATIONS
          </span>

          <h3>
            Active mentors
          </h3>

        </div>

      </div>


      <div class="pnadm-mentor-toolbar">

        <input
          type="search"
          placeholder="Search name, email, college, program or mentor ID…"
          data-pnadm-mentor-search
        >


        <select data-pnadm-mentor-status-filter>

          <option value="all">
            All statuses
          </option>

          <option value="approved">
            Approved
          </option>

          <option value="suspended">
            Suspended
          </option>

          <option value="pending">
            Pending
          </option>

        </select>


        <select data-pnadm-mentor-visibility-filter>

          <option value="all">
            All visibility
          </option>

          <option value="live">
            Live
          </option>

          <option value="unlive">
            Unlive
          </option>

        </select>


        <button
          type="button"
          data-pnadm-mentor-refresh
        >
          Refresh
        </button>

      </div>


      <div data-pnadm-mentor-list>

        <div class="pnops__state">
          Loading mentors…
        </div>

      </div>
    `;


    mentorView.appendChild(
      manager
    );


    tabs
      .querySelectorAll(
        '[data-pnadm-mentor-tab]'
      )
      .forEach(button => {

        button.addEventListener(
          'click',
          () => {

            const mode =
              button.dataset
                .pnadmMentorTab;


            tabs
              .querySelectorAll(
                '[data-pnadm-mentor-tab]'
              )
              .forEach(tab => {

                tab.classList.toggle(
                  'is-active',
                  tab === button
                );

              });


            applicationCards()
              .forEach(card => {

                card.hidden =
                  mode !==
                  'applications';

              });


            manager.hidden =
              mode !==
              'management';


            if (
              mode ===
              'management'
            ) {

              loadMentors();

            }

          }
        );

      });


    manager
      .querySelector(
        '[data-pnadm-mentor-search]'
      )
      ?.addEventListener(
        'input',
        event => {

          search =
            event.target
              .value
              .trim()
              .toLowerCase();


          render();

        }
      );


    manager
      .querySelector(
        '[data-pnadm-mentor-status-filter]'
      )
      ?.addEventListener(
        'change',
        event => {

          statusFilter =
            event.target.value;


          render();

        }
      );


    manager
      .querySelector(
        '[data-pnadm-mentor-visibility-filter]'
      )
      ?.addEventListener(
        'change',
        event => {

          visibilityFilter =
            event.target.value;


          render();

        }
      );


    manager
      .querySelector(
        '[data-pnadm-mentor-refresh]'
      )
      ?.addEventListener(
        'click',
        loadMentors
      );


    mounted =
      true;

  }


  function filtered() {

    return mentors.filter(
      mentor => {

        const status =
          String(
            mentor.status ||
            ''
          )
            .toLowerCase();


        const isLive =
          Boolean(
            mentor.is_visible
          );


        const haystack =
          JSON.stringify(
            mentor
          )
            .toLowerCase();


        const matchesSearch =
          !search ||
          haystack.includes(
            search
          );


        const matchesStatus =
          statusFilter ===
            'all' ||
          status ===
            statusFilter;


        const matchesVisibility =
          visibilityFilter ===
            'all' ||

          (
            visibilityFilter ===
              'live' &&
            isLive
          ) ||

          (
            visibilityFilter ===
              'unlive' &&
            !isLive
          );


        return (
          matchesSearch &&
          matchesStatus &&
          matchesVisibility
        );

      }
    );

  }


  function render() {

    const container =
      mentorView.querySelector(
        '[data-pnadm-mentor-list]'
      );


    if (!container) {
      return;
    }


    const rows =
      filtered();


    if (!rows.length) {

      container.innerHTML = `
        <div class="pnops__state">
          No mentors match these filters.
        </div>
      `;

      return;

    }


    container.innerHTML = `
      <div class="pnops__table-wrap">

        <table class="pnops__table">

          <thead>

            <tr>

              <th>Mentor</th>
              <th>College</th>
              <th>Rating</th>
              <th>Sessions</th>
              <th data-pn5-mentor-payment-head>
                Payments
              </th>
              <th>Status</th>
              <th>Visibility</th>
              <th>Actions</th>

            </tr>

          </thead>


          <tbody>

            ${rows
              .map(
                mentor => {

                  const status =
                    String(
                      mentor.status ||
                      ''
                    )
                      .toLowerCase();


                  const live =
                    Boolean(
                      mentor.is_visible
                    );


                  return `
                    <tr>

                      <td>

                        <span class="pnops__primary">
                          ${escapeHTML(
                            mentor.display_name ||
                            'PeerNest Mentor'
                          )}
                        </span>

                        <span class="pnops__secondary">
                          ${escapeHTML(
                            mentor.email ||
                            ''
                          )}
                        </span>

                      </td>


                      <td>
                        ${escapeHTML(
                          mentor.college_name ||
                          '—'
                        )}
                      </td>


                      <td>
                        ${escapeHTML(
                          mentor.rating ??
                          0
                        )}
                        / 5
                      </td>


                      <td>

                        <strong>
                          ${escapeHTML(
                            mentor._finance
                              ?.completed_sessions ??
                            mentor.sessions_completed ??
                            0
                          )}
                        </strong>

                        ${
                          mentor._finance
                            ? `
                              <span class="pnops__secondary">
                                ${escapeHTML(
                                  mentor._finance
                                    .upcoming_sessions ??
                                  0
                                )}
                                upcoming ·
                                ${escapeHTML(
                                  mentor._finance
                                    .cancelled_sessions ??
                                  0
                                )}
                                cancelled
                              </span>
                            `
                            : ''
                        }

                      </td>


                      <td data-pn5-mentor-payment-cell>

                        ${
                          mentor._finance
                            ? `
                              <span class="pn5-mentor-payment-total">
                                ${money(
                                  mentor._finance
                                    .total_earnings,
                                  mentor._finance
                                    .currency
                                )}
                              </span>

                              <small>
                                Paid
                                ${money(
                                  mentor._finance
                                    .paid,
                                  mentor._finance
                                    .currency
                                )}
                                · Due
                                ${money(
                                  mentor._finance
                                    .to_be_paid,
                                  mentor._finance
                                    .currency
                                )}
                              </small>

                              <button
                                type="button"
                                data-mentor-payments="${escapeHTML(
                                  mentor.mentor_id
                                )}"
                              >
                                View details
                              </button>
                            `
                            : `
                              <span class="pn5-mentor-payment-total">
                                ₹0
                              </span>

                              <small>
                                No earnings yet
                              </small>
                            `
                        }

                      </td>


                      <td>
                        ${pill(status)}
                      </td>


                      <td>
                        ${pill(
                          live
                            ? 'live'
                            : 'unlive'
                        )}
                      </td>


                      <td>

                        <div class="pnadm-mentor-actions">

                          <button
                            type="button"
                            data-mentor-visibility="${escapeHTML(
                              mentor.mentor_id
                            )}"
                            data-next-visible="${live ? 'false' : 'true'}"
                            ${status === 'approved' ? '' : 'disabled'}
                          >
                            ${
                              live
                                ? 'Unlive'
                                : 'Go Live'
                            }
                          </button>


                          ${
                            status ===
                            'approved'
                              ? `
                                <button
                                  type="button"
                                  class="is-danger"
                                  data-mentor-status="${escapeHTML(
                                    mentor.mentor_id
                                  )}"
                                  data-next-status="suspended"
                                >
                                  Suspend
                                </button>
                              `
                              : ''
                          }


                          ${
                            status ===
                            'suspended'
                              ? `
                                <button
                                  type="button"
                                  class="is-success"
                                  data-mentor-status="${escapeHTML(
                                    mentor.mentor_id
                                  )}"
                                  data-next-status="approved"
                                >
                                  Reactivate
                                </button>
                              `
                              : ''
                          }

                        </div>

                      </td>

                    </tr>
                  `;

                }
              )
              .join('')}

          </tbody>

        </table>

      </div>
    `;


    bindActions();

  }


  async function loadMentors() {

    const container =
      mentorView.querySelector(
        '[data-pnadm-mentor-list]'
      );


    if (container) {

      container.innerHTML = `
        <div class="pnops__state">
          Loading mentors…
        </div>
      `;

    }


    try {

      const results =
        await Promise.allSettled([

          window.PeerNestDB
            .request(
              'rpc/admin_list_mentors',
              '',
              {
                method:
                  'POST',

                body:{}
              }
            ),

          window.PeerNestDB
            .request(
              'rpc/admin_list_mentor_finance_v2',
              '',
              {
                method:
                  'POST',

                body:{}
              }
            )

        ]);


      if (
        results[0].status !==
        'fulfilled'
      ) {

        throw results[0].reason;

      }


      const mentorRows =
        Array.isArray(
          results[0].value
        )
          ? results[0].value
          : [];


      const financeRows =
        results[1].status ===
          'fulfilled' &&
        Array.isArray(
          results[1].value
        )
          ? results[1].value
          : [];


      const financeByMentor =
        new Map(
          financeRows.map(
            row => [
              String(
                row.mentor_id ||
                row.id ||
                ''
              ),
              row
            ]
          )
        );


      mentors =
        mentorRows.map(
          mentor => ({

            ...mentor,

            _finance:
              financeByMentor.get(
                String(
                  mentor.mentor_id ||
                  mentor.id ||
                  ''
                )
              ) ||
              null

          })
        );


      if (
        results[1].status ===
        'rejected'
      ) {

        console.warn(
          '[PeerNest Admin] mentor finance unavailable:',
          results[1].reason
        );

      }


      render();

    }
    catch (error) {

      console.error(
        '[PeerNest Admin] mentor management:',
        error
      );


      if (container) {

        container.innerHTML = `
          <div class="pnops__state pnops__state--error">
            ${escapeHTML(
              error?.message ||
              'Could not load mentors.'
            )}
          </div>
        `;

      }

    }

  }


  async function refreshStats() {

    try {

      const stats =
        await window.PeerNestDB
          .adminGetDashboardStats();


      const approved =
        dashboard.querySelector(
          '[data-pnadm-approved-mentors]'
        );


      const visible =
        dashboard.querySelector(
          '[data-pnadm-visible-mentors]'
        );


      const suspended =
        dashboard.querySelector(
          '[data-pnadm-suspended]'
        );


      if (approved) {
        approved.textContent =
          stats.approved_mentors ??
          '—';
      }


      if (visible) {
        visible.textContent =
          stats.visible_mentors ??
          '—';
      }


      if (suspended) {
        suspended.textContent =
          stats.suspended_mentors ??
          '—';
      }

    }
    catch (_) {}

  }


  function bindActions() {

    mentorView
      .querySelectorAll(
        '[data-mentor-payments]'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            async () => {

              const mentorId =
                button.dataset
                  .mentorPayments;


              try {

                if (
                  !window
                    .PeerNestAdminMentorPayments
                    ?.openDetailById
                ) {

                  throw new Error(
                    'Mentor payment details are still loading. Please try again.'
                  );

                }


                await window
                  .PeerNestAdminMentorPayments
                  .openDetailById(
                    mentorId
                  );

              }
              catch (error) {

                window.alert(
                  error?.message ||
                  'Could not open mentor payment details.'
                );

              }

            }
          );

        }
      );


    mentorView
      .querySelectorAll(
        '[data-mentor-visibility]'
      )
      .forEach(button => {

        button.addEventListener(
          'click',
          async () => {

            button.disabled =
              true;


            try {

              await window.PeerNestDB
                .request(
                  'rpc/admin_set_mentor_visibility',
                  '',
                  {
                    method:
                      'POST',

                    body:{
                      target_mentor_id:
                        button.dataset
                          .mentorVisibility,

                      make_visible:
                        button.dataset
                          .nextVisible ===
                        'true'
                    }
                  }
                );


              await loadMentors();

              await refreshStats();

            }
            catch (error) {

              alert(
                error?.message ||
                'Could not change mentor visibility.'
              );


              button.disabled =
                false;

            }

          }
        );

      });


    mentorView
      .querySelectorAll(
        '[data-mentor-status]'
      )
      .forEach(button => {

        button.addEventListener(
          'click',
          async () => {

            const next =
              button.dataset
                .nextStatus;


            if (
              next ===
              'suspended' &&
              !window.confirm(
                'Suspend this mentor? Their public profile will immediately go offline.'
              )
            ) {
              return;
            }


            button.disabled =
              true;


            try {

              await window.PeerNestDB
                .request(
                  'rpc/admin_set_mentor_status',
                  '',
                  {
                    method:
                      'POST',

                    body:{
                      target_mentor_id:
                        button.dataset
                          .mentorStatus,

                      new_status:
                        next
                    }
                  }
                );


              await loadMentors();

              await refreshStats();

            }
            catch (error) {

              alert(
                error?.message ||
                'Could not update mentor status.'
              );


              button.disabled =
                false;

            }

          }
        );

      });

  }


  function init() {

    if (
      !window.PeerNestDB
    ) {

      setTimeout(
        init,
        100
      );

      return;

    }


    mount();

  }


  document.addEventListener(
    'peernest:dashboard-ready',
    init
  );


  init();

})();
